module.exports = __webpack_public_path__ + "static/img/og-label.9c74d616.png";